import Box from '@mui/material/Box';
import React from 'react';

interface Props {
    currentIndex: number;
    total: number;
}

export const WhatsNewFooter: React.FC<Props> = ({ currentIndex, total }) => (
    <Box
        sx={{
            position: 'absolute',
            left: 16,
            bottom: 16,
            color: 'text.secondary',
            fontSize: 14,
        }}
    >
        {`${currentIndex + 1} of ${total}`}
    </Box>
);
